import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import Amplify, {Auth} from 'aws-amplify';
import * as serviceWorker from './serviceWorker';
import * as awsConfig from './.aws-config.js';
import './styles/index.scss';
import AuthConfig from './.auth-config';
import { captureDeepLinkTarget } from './services/deepLinkTarget';

captureDeepLinkTarget();

Amplify.configure(awsConfig);
Auth.configure({oauth: AuthConfig});
ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
